import { disableScrollingPrevention, theme } from '@arnold/common';
import styled from '@emotion/styled';
import { FC, useContext, useState } from 'react';
import { ReactComponent as CloseMenu } from '../../../assets/images/CloseMenu.svg';
import { ReactComponent as Menu } from '../../../assets/images/Menu.svg';
import { usePushReportEvent } from '../../ReportGTMContext';
import { SideMenuContext } from './SideMenuContext';
import type { Sections } from './types';

type SideMenuProps = Readonly<{
  sections: Sections;
}>;

const StyledButton = styled.button`
  box-shadow: ${theme.shadows.elevationContentBlockOutstanding} !important;
`;

const ReportSideMenu = styled.ul`
  max-height: calc(100vh - 450px);
  overflow: auto;
`;

export const SideMenu: FC<SideMenuProps> = ({ sections }) => {
  const [open, setOpen] = useState<boolean>(false);

  const { visibleSectionId } = useContext(SideMenuContext);
  const pushReportEvent = usePushReportEvent();
  const handleSetOpen = () => setOpen(!open);

  const handleNavClick = (sectionId: string) => {
    disableScrollingPrevention(1000);
    pushReportEvent('right-navigation-click', 'click', { section_id: sectionId });
  };

  return (
    <div className={'nav-aside ' + (open ? 'nav-aside--open' : '')}>
      <StyledButton type="button" className={'nav-aside__toggle btn btn-link shadow-sm'} onClick={handleSetOpen}>
        {open ? <CloseMenu role="img" aria-label="close menu" /> : <Menu role="img" aria-label="menu" />}
      </StyledButton>
      <ReportSideMenu className="nav-aside__menu shadow-sm" data-icom={'report-side-menu'}>
        {sections.map((section: { id: string; headingLocal: string }) => (
          <li key={section.id} className={visibleSectionId === section.id ? 'active' : ''}>
            <a href={'#' + section.id.replace(/\W/g, '_')} onClick={() => handleNavClick(section.id)}>
              {section.headingLocal || section.id}
            </a>
          </li>
        ))}
      </ReportSideMenu>
    </div>
  );
};
